<div class="lgcnt">
  <div class="login-container">
    <h2 class="login_title">Login</h2>
    <form (ngSubmit)="login()" #loginForm="ngForm">
      <div class="form-group">
        <label for="email" class="labl">Email:</label>
        <input type="email" id="email" name="email" required [(ngModel)]="email" #emailInput="ngModel">
        <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="alert alert-danger">
          <div *ngIf="emailInput.errors.required">Email is required.</div>
          <div *ngIf="emailInput.errors.email">Please enter a valid email.</div>
        </div>
      </div>
  
      <div class="form-group">
        <label for="password" class="labl">Password:</label>
        <div class="password-container">
          <input [type]="passwordFieldType" id="password" name="password" required [(ngModel)]="password" #passwordInput="ngModel">
          <mat-icon class="toggle-password" (click)="togglePasswordVisibility()">{{ passwordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</mat-icon>
        </div>
        <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)" class="alert alert-danger">
          <div *ngIf="passwordInput.errors.required">Password is required.</div>
        </div>
      </div>
  
      <button type="submit" [disabled]="loginForm.invalid" class="login_btn">Login</button>
    </form>
  </div>
</div>